import { render, staticRenderFns } from "./AddPersonForm.vue?vue&type=template&id=7cec22be&scoped=true&"
import script from "./AddPersonForm.vue?vue&type=script&lang=ts&"
export * from "./AddPersonForm.vue?vue&type=script&lang=ts&"
import style0 from "./AddPersonForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AddPersonForm.vue?vue&type=style&index=1&id=7cec22be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cec22be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
